/**
 * Component - v2.1.0
 */

// Libraries
import React from 'react';

// Supermove
import {Styled} from '@supermove/components';
import {colors, fontWeight} from '@supermove/styles';

// App
import SyncInventoryForm from '@shared/modules/Inventory/forms/SyncInventoryForm';

const Container = Styled.View`
  flex-direction: row;
`;

const Section = Styled.View`
  width: 50px;
  align-items: flex-end;
`;

const Title = Styled.H8`
  font-size: 8px;
  color: ${colors.gray.tertiary};
  text-transform: uppercase;
`;

const Count = Styled.H8`
  ${fontWeight(700)}
  color: ${colors.gray.primary};
`;

const SyncInventoryCounts = ({syncInventoryForm}: any) => {
  return (
    <Container>
      <Section>
        <Title>Take</Title>
        <Count>{SyncInventoryForm.getTakeCount(syncInventoryForm)}</Count>
      </Section>
      <Section>
        <Title>Leave</Title>
        <Count>{SyncInventoryForm.getLeaveCount(syncInventoryForm)}</Count>
      </Section>
      <Section>
        <Title>CU FT</Title>
        <Count>{SyncInventoryForm.getTotalVolume(syncInventoryForm)}</Count>
      </Section>
      <Section>
        <Title>LB</Title>
        <Count>{SyncInventoryForm.getTotalWeight(syncInventoryForm)}</Count>
      </Section>
    </Container>
  );
};

export default SyncInventoryCounts;
